import { render } from "./AddDelivery.vue?vue&type=template&id=3988c272"
import script from "./AddDelivery.vue?vue&type=script&lang=js"
export * from "./AddDelivery.vue?vue&type=script&lang=js"
script.render = render

export default script